import { ConfigService } from '@core/shared/config';
import { ProtocolLoggerMemoryStorage, StorageProtocolLogger } from '@core/shared/protocol';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/config";
/** A logger which exposes its data on dev console (@common/console, not dev tools!) */
export let DevConsoleProtocolLogger = /*#__PURE__*/(() => {
  class DevConsoleProtocolLogger extends StorageProtocolLogger {
    constructor(config) {
      super();
      this.config = config;
    }
    createStorage() {
      return new ProtocolLoggerMemoryStorage(this.name);
    }
    static {
      this.ɵfac = function DevConsoleProtocolLogger_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DevConsoleProtocolLogger)(i0.ɵɵinject(i1.ConfigService));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: DevConsoleProtocolLogger,
        factory: DevConsoleProtocolLogger.ɵfac
      });
    }
  }
  return DevConsoleProtocolLogger;
})();